import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

Vue.use(VueI18n)

// 创建i18n实例
const i18n = new VueI18n({
  locale: 'zh-CN', // 默认语言
  fallbackLocale: 'zh-CN', // 回退语言
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  },
  silentTranslationWarn: true // 静默翻译警告
})

// 语言切换函数
export const setLanguage = (lang) => {
  i18n.locale = lang
  localStorage.setItem('preferred-language', lang)
}

// 获取当前语言
export const getCurrentLanguage = () => {
  return i18n.locale
}

// 初始化语言设置
export const initLanguage = () => {
  const savedLang = localStorage.getItem('preferred-language')
  if (savedLang && (savedLang === 'zh-CN' || savedLang === 'en-US')) {
    i18n.locale = savedLang
  } else {
    // 根据浏览器语言自动设置
    const browserLang = navigator.language || navigator.userLanguage
    if (browserLang.startsWith('en')) {
      i18n.locale = 'en-US'
    } else {
      i18n.locale = 'zh-CN'
    }
  }
}

export default i18n
